import React from 'react';
import { Pie } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { IPieChartData } from '../interfaces/shared/IChart';

// Register the necessary Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface IProps {
  data: IPieChartData;
}
const PieChart: React.FC<IProps> = ({ data }) => {
  // Chart configuration options
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true, // Enable the title
        text: 'Expenses', // Set the title text
        font: {
          size: 20, // Customize the font size
        },
        padding: {
          top: 10,
          bottom: 30,
        },
        color: '#333',
      },
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            const value = context.raw;
            const total = context.dataset.data.reduce(
              (sum: number, val: number) => sum + val,
              0,
            );
            const percentage = ((value / total) * 100).toFixed(2);
            return `${context.label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '400px', marginBottom: '20px' }}>
      <Pie data={data} options={options as any} />
    </div>
  );
};

export default PieChart;
